import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../config";
import {
    Box,
    Typography,
    Button,
    TextField,
    Slider,
    CircularProgress,
    Alert,
    AppBar,
    Toolbar,
} from "@mui/material";
import axiosExt from '../axios';
//import logo from '../assets/logo.png';
import logo from '../assets/DaCustomsLogo5Small.png';
import { useTranslation } from "react-i18next";

type ValidationState = "pending" | "valid" | "invalid";
export default function SurveyPage() {
    const { t } = useTranslation();

    const { orderId, contactId } = useParams();
        
    const [valid, setValid] = useState<ValidationState>("pending");

    const [score, setScore] = useState<number>(5);
    const [orderNumber, setOrderNumber] = useState<string>("");
    const [comment, setComment] = useState("");
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        async function checkOrder() {
            try {
                const res = await axiosExt.get(`${API_BASE_URL}/satisfactionsurvey/${orderId}`);
                if (res.status === 200) {
                    setValid("valid");
                    setOrderNumber(res.data.internalOrderNumber);
                }
            } catch {
                setValid("invalid");
            }
        }
        if (orderId) checkOrder();
    }, [orderId]);

    const handleSubmit = async () => {
        try {
            await axiosExt.post(`${API_BASE_URL}/satisfactionsurvey/submit`, {
                orderId,
                contactId: contactId || null,
                score,
                comment
            });
            setSubmitted(true);
        } catch {
            alert("Error submitting survey");
        }
    };



    return (
        <Box sx={{ width: "100%", minHeight: "100vh" }}>
            {/* --- Top Menu --- */}
            <AppBar position="static" color="default" sx={{ mb: 4, width: "100%" }}>
                <Toolbar sx={{ justifyContent: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={logo}
                            style={{ height: 40, marginRight: 12 }}
                        />
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "calc(100vh - 64px)" // 64px is AppBar height
            }}>
                {valid === "invalid" && <Alert severity="error">{t("Invalid Order")}</Alert>}
                {valid === "pending" && <CircularProgress />}

                {valid && submitted && (
                    <Typography variant="h5" gutterBottom>
                        {t("Thank you for your feedback!")}
                    </Typography>
                )}

                {valid && !submitted && (
                    <>
                        <Typography variant="h5" gutterBottom>
                            {t("How satisfied are you with our service?")}
                        </Typography>
                        {orderNumber && (
                            <Typography variant="subtitle1" gutterBottom>
                                {t("Order #")}: {orderNumber}
                            </Typography>
                        )}
                        <Slider
                            value={score}
                            onChange={(_, val) => setScore(val as number)}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            valueLabelDisplay="on"
                        />
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            margin="normal"
                            label={t("Comments (optional)")}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        <Button variant="contained" onClick={handleSubmit}>
                            {t("Submit")}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
}
